import cn from 'classnames';
import type React from 'react';
import { useRef } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';



import { useOutsideClick } from './model';
import * as st from './styles.module.scss';





interface ItemProps extends React.HTMLAttributes<HTMLDivElement> {
	isActive?: boolean;
	children?: React.ReactNode;
}

export const MenuItem: React.FC<ItemProps> = ({ isActive, children, ...props }) => {
	return (
		<div className={cn(st.item, isActive && st.active)} {...props}>
			{children}
		</div>
	);
};

interface MenuProps {
	referenceEl: Element | null;
	popperEl: HTMLElement | null;
	setPopperEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
	onAfterClose?: () => void;
	offset?: [number, number],
	dropdownClasses?: string,
	children?: React.ReactNode;
	programId?: number;
}

export const MenuDropdown: React.FC<MenuProps> = ({
	referenceEl,
	popperEl,
	setPopperEl,
	onAfterClose,
	offset = [0, 8],
	dropdownClasses,
	children,
	programId,
}) => {
	const refPopperEl = useRef(null);
	const { styles, attributes } = usePopper(referenceEl, popperEl, {
		placement: 'bottom-end',
		modifiers: [
			{
				name: 'offset',
				options: {
					offset: offset,
				},
			},
		],
	});

	const onClose = () => {
		popperEl?.setAttribute('data-show', 'false');
		referenceEl?.setAttribute('data-show', 'false');
		if (onAfterClose) onAfterClose();
	};

	useOutsideClick([refPopperEl], onClose);


	const root = document.querySelector('#root');

	return (
		<>
			{root &&
				ReactDOM.createPortal(
					<div
						ref={setPopperEl}
						style={styles.popper}
						className={cn(st.dropdown, dropdownClasses)}
						{...attributes.popper}
					>
						<div ref={refPopperEl} className={st.innerWrapper}>
							{children}
						</div>
					</div>,
					root
				)}
		</>
	);
};